import React, { useId, useMemo } from "react";

/**
 * Lightweight SVG sparkline (no Chart.js) for analytics cards.
 */
export default function MiniSparkline({ data = [], color = "#50cd89", height = 52, className = "" }) {
  const gradId = useId().replace(/[^a-zA-Z0-9-_]/g, "");
  const pathD = useMemo(() => {
    const vals = (data || []).map((v) => Number(v) || 0);
    if (!vals.length) return null;
    const w = 140;
    const h = height;
    const padX = 2;
    const padY = 4;
    const min = Math.min(...vals);
    const max = Math.max(...vals);
    const span = max - min || 1;
    const innerW = w - padX * 2;
    const innerH = h - padY * 2;
    const pts = vals.map((v, i) => {
      const x = padX + (vals.length === 1 ? innerW / 2 : (i / (vals.length - 1)) * innerW);
      const y = padY + innerH - ((v - min) / span) * innerH;
      return { x, y };
    });
    const line = pts.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(" ");
    const area = `M ${pts[0].x.toFixed(1)} ${h - padY} L ${pts.map((p) => `${p.x.toFixed(1)} ${p.y.toFixed(1)}`).join(" L ")} L ${pts[pts.length - 1].x.toFixed(1)} ${h - padY} Z`;
    return { line, area };
  }, [data, height]);

  if (!pathD) {
    return (
      <div className={`dash-mini-spark dash-mini-spark--empty ${className}`} style={{ height }} aria-hidden />
    );
  }

  return (
    <svg
      className={`dash-mini-spark ${className}`}
      width="100%"
      height={height}
      viewBox="0 0 140 52"
      preserveAspectRatio="none"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.22" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={pathD.area} fill={`url(#${gradId})`} stroke="none" />
      <path d={pathD.line} fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
